<script lang="ts" setup>
import { ref, computed } from 'vue'
import type { PropType } from 'vue'
import BsMediaSlideshow from '@/legacy/components/MediaSlideshow.vue'
import BsDialogFull from '@/legacy/components/DialogFull.vue'

const props = defineProps({
	mediaList: {
		type: Object as PropType<
			{
				type: string
				content: string
				id?: string
				preview?: string
			}[]
		>,
		default: () => [],
	},
	textClose: {
		type: String,
		default: 'Close',
	},
	imgAltText: {
		type: String,
		default: 'Image',
	},
})

const galleryIndex = ref(0)
const isShowFullMediaDialog = ref(false)
const maxItemCount = 5

const mediaListFianl = computed(() => {
	if (props.mediaList.length > maxItemCount) {
		return props.mediaList.slice(0, maxItemCount)
	}
	return props.mediaList
})

const pagination = computed(() => {
	return `${galleryIndex.value + 1} / ${mediaListFianl.value.length}`
})

function setGalleryIndex(index: number) {
	galleryIndex.value = index
}

function showFullScreenDialog() {
	isShowFullMediaDialog.value = true
}

function hideFullScreenDialog() {
	isShowFullMediaDialog.value = false
}
</script>

<template>
	<div class="bs-gallery-slideshow" v-cloak>
		<BsMediaSlideshow
			:mediaList="mediaListFianl"
			:galleryIndex="galleryIndex"
			:isGallery="true"
			:imgAltText="imgAltText"
			@setGalleryIndex="setGalleryIndex"
			@showFullScreenDialog="showFullScreenDialog"
		/>
		<Teleport to="body">
			<BsDialogFull
				class="bs-gallery-slideshow__dialog"
				v-model="isShowFullMediaDialog"
				:isFullScreen="true"
				@on-hide="hideFullScreenDialog"
			>
				<template v-slot:header>
					<div class="bs-gallery-slideshow__dialog-header">
						<div
							class="bs-gallery-slideshow__dialog-header-arrow-left"
							@click="hideFullScreenDialog"
						>
							<i class="bs-icon">
								<span
									class="bs-gallery-slideshow__dialog-header-arrow-left-icon"
								></span>
							</i>
						</div>
						<div class="bs-gallery-slideshow__dialog-header-center">
							{{ pagination }}
						</div>
						<div
							class="bs-gallery-slideshow__dialog-header-right"
							@click="hideFullScreenDialog"
						>
							<div class="bs-gallery-slideshow__dialog-header-right-close">
								<i class="bs-icon">
									<span
										class="bs-gallery-slideshow__dialog-header-right-close-icon"
									></span>
								</i>
							</div>
							{{ textClose }}
						</div>
					</div>
				</template>
				<template #content>
					<div class="bs-gallery-slideshow__dialog-content">
						<BsMediaSlideshow
							v-if="isShowFullMediaDialog"
							:isFullScreen="true"
							:isShowFullMediaDialog="isShowFullMediaDialog"
							:isGallery="true"
							:mediaList="mediaListFianl"
							:galleryIndex="galleryIndex"
							:imgAltText="imgAltText"
							@setGalleryIndex="setGalleryIndex"
						/>
					</div>
				</template>
			</BsDialogFull>
		</Teleport>
	</div>
</template>
